import { message } from "antd";

/**
 * Download a file and return a Promise.
 * Can be awaited to show a spinner while downloading.
 * @param {Object} options
 * @param {string|Blob} options.fileUrl - URL or Blob of the file
 * @param {string} options.fileName - Name for the downloaded file
 * @param {string} [options.successMessage] - Success notification message
 * @param {string} [options.errorMessage] - Error notification message
 * @returns {Promise<void>}
 */
export const downloadToSystem = ({ fileUrl, fileName, successMessage = "File downloaded successfully", errorMessage = "Failed to download file" }) => {
  return new Promise((resolve, reject) => {
    try {
      let blobUrl;

      if (fileUrl instanceof Blob) {
        blobUrl = URL.createObjectURL(fileUrl);
      } else {
        blobUrl = fileUrl;
      }

      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = fileName;

      document.body.appendChild(link);

      // Listen for the click to complete (optional)
      link.addEventListener("click", () => {
        document.body.removeChild(link);
        if (fileUrl instanceof Blob) URL.revokeObjectURL(blobUrl);
        message.success(successMessage);
        resolve(); // Resolve the promise when download triggered
      });

      link.click();
    } catch (error) {
      console.error("Download error:", error);
      message.error(errorMessage);
      reject(error);
    }
  });
};
